import { useElementBounding } from '@vueuse/core';

const appSearchRef = ref<HTMLElement | null>(null);
const { bottom: searchOffsetFromTop, update: updateSearchOffsetFromTop } = useElementBounding(appSearchRef);

export function useAppSearchBounding() {
  return {
    appSearchRef,
    searchOffsetFromTop,
    updateSearchOffsetFromTop,
  };
}